import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { createSelector } from 'reselect';
// @ts-ignore
export var applicationSelector = function applicationSelector(store) {
  return store.application || {};
};
export var applicationIdSelector = createSelector(applicationSelector, function (application) {
  return application.applicationId;
});
export var permissionsSelector = createSelector(applicationSelector, function (application) {
  return application ? application.permissions : false;
});
export var applicationCurrentApplicationSelector = createSelector(applicationSelector, function (application) {
  return application.application;
});
export var applicationDownloadFilesLinkSelector = createSelector(applicationCurrentApplicationSelector, function (application) {
  return application && application.download_files_link;
});
export var applicationCurrentProgramSelector = createSelector(applicationSelector, function (application) {
  return application && application.application && application.application.program;
});
export var applicationCurrentSchoolSelector = createSelector(applicationSelector, function (application) {
  return application && application.application && application.application.school;
});
export var applicationCurrentStudentSelector = createSelector(applicationSelector, function (application) {
  return application && application.application && application.application.student;
});
export var applicationCurrentStatusSelector = createSelector(applicationSelector, function (application) {
  return application && application.application && application.application.status;
});

/* === Requirements === */

export var canAddRequirementSelector = createSelector(applicationSelector, function (application) {
  return application.permissions.create_requirement_with_template || application.permissions.create_requirement_without_template;
});
export var canIndexRequirementSelector = createSelector(applicationSelector, function (application) {
  return application.permissions.index_requirement;
});
export var selectedPreviewRequirementIdSelector = createSelector(applicationSelector, function (application) {
  return application.selectedPreviewRequirementId;
});
export var stageReqsOutstandingSelector = createSelector(applicationSelector, function (application) {
  return application.stageReqsOutstanding;
});

/* === NOTES === */

export var applicationNotes = createSelector(applicationSelector, function (application) {
  return application.notes;
});
export var notesFilterSelector = createSelector(applicationNotes, function (notes) {
  return notes.filter;
});
export var notesAlertOnlySelector = createSelector(applicationNotes, function (notes) {
  return notes.withAlertOnly;
});
export var addingNotes = createSelector(applicationSelector, function (application) {
  return application.notes.addingNote;
});
export var newNoteSelector = createSelector(applicationNotes, function (notes) {
  return notes.newNote;
});
export var newNoteLoadingSelector = createSelector(applicationNotes, function (notes) {
  return notes.newNoteLoading;
});
export var addingPrivateNotes = createSelector(applicationSelector, function (application) {
  return application.notes.addingPrivateNote;
});
export var newPrivateNoteSelector = createSelector(applicationNotes, function (notes) {
  return notes.newPrivateNote;
});
export var newPrivateNoteLoadingSelector = createSelector(applicationNotes, function (notes) {
  return notes.newPrivateNoteLoading;
});
export var notesMapSelector = createSelector(applicationNotes, function (notes) {
  return notes.byIndex;
});
export var applicationAgentId = createSelector(applicationCurrentApplicationSelector, function (application) {
  return application && application.agent ? application.agent.id : null;
});
export var applicationAgentFirstName = createSelector(applicationCurrentApplicationSelector, function (application) {
  return application && application.agent && application.agent.first_name;
});
export var applicationStudentFirstName = createSelector(applicationCurrentStudentSelector, function (student) {
  return student && student.personal_information && student.personal_information.first_name;
});
export var applicationLoadingSelector = createSelector(applicationSelector, function (application) {
  return application.loading;
});